import axios from 'axios';

export default class ConnectomeService {
  public getConnectomeByLogin(login: any) {
    const param = '?login='.concat(login);
    return axios.get('/api/connectome-feed/getByUserId' + param);
  }

  public getConnectomeByLoginOrPhone(login: any) {
    const param = '?loginOrPhoneNumber='.concat(login);
    return axios.get('/api/connectome-feed/getByLoginOrPhoneNumber' + param);
  }
}
